import { render, staticRenderFns } from "./MedicalNecessity.vue?vue&type=template&id=49c27e7b&scoped=true&"
import script from "./MedicalNecessity.vue?vue&type=script&lang=js&"
export * from "./MedicalNecessity.vue?vue&type=script&lang=js&"
import style0 from "./MedicalNecessity.vue?vue&type=style&index=0&id=49c27e7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.registry.npmjs.org/vue-loader/15.9.7_css-loader@3.6.0+webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c27e7b",
  null
  
)

export default component.exports